import 'bootstrap'
import 'jquery-ujs'
import toastr from 'toastr';

window.toastr = toastr;

var Turbolinks = require("turbolinks");
Turbolinks.start();
